<template>
  <v-card outlined class="rounded-lg">
    <v-card elevation="0" class="rounded-t-lg rounded-b-0 lh-1">
      <div id="yt-player" style="width: 100%"></div>
    </v-card>
    <div class="pa-4 pb-2">
      <div class="d-flex align-center gap-4">
        <v-icon color="primary" large>
          {{ categories[changelog?.category]?.icon }}
        </v-icon>
        <div>
          <v-chip color="primary" x-small label>
            {{ categories[changelog?.category]?.text }}
          </v-chip>
          <v-chip
            v-if="changelog?.size === 'LARGE'"
            color="success"
            x-small
            label
            class="ml-1"
          >
            Grande atualização
          </v-chip>
          <h6 class="mb-0">{{ changelog?.title }}</h6>
        </div>
      </div>
      <base-md-viewer
        :value="changelog?.content || ''"
        :holder="`changelog-${changelog?.id}`"
      >
      </base-md-viewer>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    changelog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      categories: {
        NEW_FEATURE: { text: "Nova Funcionalidade", icon: "mdi-plus" },
        PERFORMANCE: {
          text: "Atualização de Desempenho",
          icon: "mdi-speedometer",
        },
        SECURITY: {
          text: "Atualização de Segurança",
          icon: "mdi-shield-check",
        },
        BUG_FIX: { text: "Correção de Bug", icon: "mdi-bug" },
        NEW_API: { text: "Nova API", icon: "mdi-api" },
        NEW_REPORT: { text: "Novo Relatório", icon: "mdi-chart-box" },
        NEW_UI: { text: "Nova Interface", icon: "mdi-palette" },
        NEW_TOOL: { text: "Nova Ferramenta", icon: "mdi-wrench" },
        OTHER: { text: "Nova Atualização", icon: "mdi-shimmer" },
      },
    };
  },
  mounted() {
    window.onYouTubeIframeAPIReady = this.initYoutubePlayer;
    if (this.changelog.youtubeUrl) this.loadYoutubePlayerScript();
  },
  beforeDestroy() {
    window.onYouTubeIframeAPIReady = null;
  },
  methods: {
    loadYoutubePlayerScript() {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      console.log("loadYoutubePlayerScript");
    },
    initYoutubePlayer() {
      console.log("initYoutubePlayer");
      const player = new YT.Player("yt-player", {
        videoId: this.changelog.youtubeUrl,
      });
    },
  },
  watch: {
    "changelog.youtubeUrl": {
      handler(value) {
        if (value) this.loadYoutubePlayerScript();
      },
    },
  },
};
</script>
